export const es = {
  dashboard: 'Panel de Control',
  location: 'Ubicación',
  photos: 'Fotos',
  history: 'Historial',
  settings: 'Configuración',
  connected: 'Conectado',
  connecting: 'Conectando',
  disconnected: 'Desconectado',
  error: 'Error',
  reconnect: 'Reconectar',
  photoData: 'Datos de Fotos',
  audioData: 'Datos de Audio',
  gpsData: 'Datos GPS',
  realtimeData: 'Datos en Tiempo Real',
  waitingForData: 'Esperando datos...',
  gpsDataList: 'Lista de Datos GPS',
  waitingForGps: 'Esperando datos GPS...',
  diaryHistory: 'Historial del Diario',
  underDevelopment: 'Función en desarrollo'
};